<template>
  <div class="Contact">
    <!-- <div class="ContactComcontainer crumbs">
      <router-link to="/">Home</router-link> &gt; About EZFM
    </div> -->
    <div class="ContactComcontainer connect-wrap">
      <h3>Connect EZFM</h3>
      <div class="EZFM-con-box">
        <h4>轻松调频 EZFM</h4>
        <p>地址:中国北京石景山路甲16号 中国国际广播电台 100040</p>
        <p>Address : 16 A Shijingshan Road, Beijing , China 100040</p>
        <p>Email: CRIEZFM@cri.com.cn</p>
        <p>Website: ezfm.cri.cn</p>
        <ul>
          <li>
            <em>微信公众号</em>
            <img src="../../static/img/weixin_code.jpg" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",
  data() {
    return {
      msg: "live",
    };
  },
};
</script>


<style scoped lang="scss">
.Contact {
  background: #f3f4f5;
}
.ContactComcontainer {
  width: 1280px;
  margin: 0 auto;
}
.crumbs {
  padding: 17px 0 27px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #999;
  display: block;
  a {
    color: #999;
  }
}
//--
.connect-wrap {
  font-size: 16px;
  line-height: 1.8em;
  padding: 0px 0px 67px 0px;
  margin-top: 30px;
  h3 {
    font-size: 24px;
    color: #333;
  }
  .EZFM-con-box {
    h4 {
      margin-top: 25px;
      font: 24px/48px "Microsoft Yahei";
      color: #01aef0;
    }

    p {
      margin-top: 20px;
      text-align: justify;
      color: black;
    }
    ul {
      margin-top: 50px;
      width: 100%;
      overflow: hidden;
      li {
        float: left;
        width: 200px;
        margin: 0 20px 30px 0;
        em {
          display: block;
          font: normal 18px/30px "Microsoft Yahei";
          background-color: #e8e8e8;
          text-align: center;
          margin-bottom: 20px;
        }
        img {
          max-width: 100%;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 900px) {
  * {
    box-sizing: border-box;
  }
  .Contact {
    background: #fff;
  }
  .crumbs {
    display: none;
  }
  .ContactComcontainer {
    width: 100%;
  }
  .connect-wrap {
    padding: 30px 2% 130px 2%;
    margin-top: 0px;
    h3 {
      font-size: 24px;
      color: #333;
    }
    .EZFM-con-box {
      h4 {
        margin-top: 25px;
        font: 24px/48px "Microsoft Yahei";
        color: #01aef0;
      }
      p {
        margin-top: 20px;
        text-align: justify;
        color: black;
      }
      ul {
        margin-top: 50px;
        width: 100%;
        overflow: hidden;
        flex-wrap: wrap;
        display: flex;
        li {
          width: 48%;

          display: inline-block;

          margin: 0 20px 30px 0;
          margin-right: 4%;
          em {
            margin-bottom: 10px;
            display: block;
            font: normal 18px/30px "Microsoft Yahei";
            background-color: #e8e8e8;
            text-align: center;
          }
          img {
            max-width: 100%;
            display: block;
            margin: 0 auto;
          }
        }
        li:nth-child(2n) {
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/Contact.vue